import { render } from "./UserTransactionsTable.vue?vue&type=template&id=1f7b47ee&scoped=true"
import script from "./UserTransactionsTable.vue?vue&type=script&lang=js"
export * from "./UserTransactionsTable.vue?vue&type=script&lang=js"

import "./UserTransactionsTable.vue?vue&type=style&index=0&id=1f7b47ee&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7b47ee"],['__file',"src/components/UserTransactionsTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f7b47ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f7b47ee', __exports__)) {
    console.log('reload')
    api.reload('1f7b47ee', __exports__)
  }
  
  module.hot.accept("./UserTransactionsTable.vue?vue&type=template&id=1f7b47ee&scoped=true", () => {
    console.log('re-render')
    api.rerender('1f7b47ee', render)
  })

}


export default __exports__